import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { deletedstaff } from "../../../services/admin";

export default function DeletedStaff() {
    const [rows, setRows] = useState([]);

    const columnDefs = [
        { headerName: "Staff Name", field: "staff_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Staff Code", field: "staff_code", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        {
            headerName: "DOB", field: "date_of_birth", sortable: true, resizable: true, cellStyle: { textAlign: "left" },
            cellRenderer: (p) => (p.value ? moment(p.value).format("DD-MM-YYYY") : ""),
        },
        { headerName: "Gender", field: "gender", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Type", field: "role_name", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Email", field: "email", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
        { headerName: "Mobile", field: "phone", sortable: true, resizable: true, cellStyle: { textAlign: "left" } },
    ];

    useEffect(() => {
        deletedstaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setRows(res.data.details);
            }
        });
    }, []);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Deleted Staff</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Staff</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Deleted Staff</li>
                </ol>
            </div>
            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Deleted Staff List</h2>
                            </div>
                            <div className="card-body">
                                <div className="ag-theme-alpine ag-style mt-2">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={rows}
                                        pagination="true"
                                        paginationPageSize="10"
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
